import { useAtomValue } from "jotai";
import { useLocation } from "react-router-dom";
import { LOGGED_HOME_PAGE_PATH } from "../../constants/env";
import { BackButtonStore } from "../stores/backButtonStore";
import type { Location } from "react-router-dom";

const pathWithBackToSections: string[] = ["sorry"];

interface PathBacksInterface {
  match: string;
  backTo: string;
}

const pathBacks: PathBacksInterface[] = [
  {
    match: "",
    backTo: "",
  },
];

export interface BackButtonHookInterface {
  goBack?: boolean;
  url: string;
  action?: () => void;
  defaultBackUrl?: string;
}

function isAnyIncludedInLocationPathname(location: Location, pathWithBackToSections: string[]) {
  return pathWithBackToSections.some((path) => location.pathname.includes(path));
}

interface ShouldGoBackToProfileArgs {
  location: Location;
  backButton?: BackButtonHookInterface;
  pathWithBackToSections: string[];
}

function shouldGoBackToProfile({ location, backButton, pathWithBackToSections }: ShouldGoBackToProfileArgs) {
  return backButton === undefined && isAnyIncludedInLocationPathname(location, pathWithBackToSections);
}

export function useBackButton(): BackButtonHookInterface | undefined {
  const backButton = useAtomValue(BackButtonStore);
  const location = useLocation();

  if (backButton?.url === location.pathname) return { ...backButton, url: LOGGED_HOME_PAGE_PATH };

  if (shouldGoBackToProfile({ location, backButton, pathWithBackToSections })) {
    return { url: "/profile" };
  }

  const { backTo } = pathBacks.find((path) => path.match === location.pathname) || {};
  if (backTo) return { ...backButton, url: backTo };

  return backButton;
}
